import DataTable from '@components/DataTable';
import { Container, TableSymbol } from './styled';
import { RouterLink } from '@redux-first-router-link';
import { SWS_HOST } from '@/constants';
import { useTranslation } from '@/hooks/useTranslation';

export interface IExchangeItem {
  tickerSymbol: string;
  exchangeSymbol: string;
  exchangeName: string;
  primarySecurity: string;
  securityName: string;
  exchangeCountryIso: string;
  currencyIso: string;
  startDate: string;
  canonicalUrl?: string;
}

interface ExchangeListingProps {
  list: IExchangeItem[];
}

const ExchangeListing = ({ list }: ExchangeListingProps) => {
  const t = useTranslation();
  return (
    <Container data-cy-id="exchange-listing">
      <DataTable>
        <thead>
          <tr>
            <th>
              {t('page.companyReport.information.listings.table.header1')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header2')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header3')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header4')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header5')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header6')}
            </th>
            <th>
              {t('page.companyReport.information.listings.table.header7')}
            </th>
          </tr>
        </thead>
        <tbody>
          {list.map((n, i) => (
            <tr key={i} data-cy-id="exchange-listing-item">
              <td data-cy-id="listing-ticker">
                {n.canonicalUrl ? (
                  <TableSymbol
                    as={RUNTIME_ENV === 'native' ? RouterLink : 'a'}
                    href={
                      RUNTIME_ENV === 'native'
                        ? n.canonicalUrl
                        : `${SWS_HOST}${n.canonicalUrl}`
                    }
                    to={n.canonicalUrl}
                    target={RUNTIME_ENV === 'native' ? undefined : '_blank'}
                  >
                    <b data-cy-id="ticker-symbol">{n.tickerSymbol}</b>
                  </TableSymbol>
                ) : (
                  <>{n.tickerSymbol}</>
                )}
              </td>
              <td data-cy-id="listing-name">
                {n.exchangeSymbol} ({n.exchangeName})
              </td>
              <td data-cy-id="listing-primary">{n.primarySecurity}</td>
              <td data-cy-id="listing-type">{n.securityName}</td>
              <td data-cy-id="listing-country">{n.exchangeCountryIso}</td>
              <td data-cy-id="listing-currency">{n.currencyIso}</td>
              <td data-cy-id="listing-date">{n.startDate}</td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </Container>
  );
};

export default ExchangeListing;
